import { Modal } from "react-bootstrap";


interface RefreshOnClick {
    anyUnderAgeMember: boolean,
    setUnderAgeModal: (value: boolean) => void

    isAlreadyInvited: boolean,
    setAlreadyInvitedValue: (value: boolean) => void

    hostNotAcceptOffer: boolean
    setHostNotAcceptOffer: (value: boolean) => void
}

const ValidationModals: React.FC<RefreshOnClick> = ({ anyUnderAgeMember, setUnderAgeModal, isAlreadyInvited, setAlreadyInvitedValue, hostNotAcceptOffer, setHostNotAcceptOffer }) => {


    return (
        <>
            <Modal centered show={anyUnderAgeMember} id="underAgeMemberModal">
                <Modal.Body className="text-center">
                    Some of the guests in this group are younger than the minimum age.
                </Modal.Body>

                <Modal.Footer>
                    <button className="link btns btnMO justify-content-center d-flex  align-content-center  col-12 mt-2 mb-2"
                        onClick={() => { setUnderAgeModal(false) }}>
                        Ok
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal centered show={isAlreadyInvited} id="alreadyInvitedModal">
                <Modal.Body className="text-center">
                    You have already invited this group to join your table. If they accept your offer you can chat to them.
                </Modal.Body>

                <Modal.Footer>
                    <button className="link btns btnMO justify-content-center d-flex  align-content-center  col-12 mt-2 mb-2"
                        onClick={() => { setAlreadyInvitedValue(false) }}>
                        Ok
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal centered show={hostNotAcceptOffer} id="hostNotAcceptOfferModal">
                <Modal.Body className="text-center">
                    You ca only invite guests to your table if you accept an offer.
                </Modal.Body>

                <Modal.Footer>
                    <button className="link btns btnMO justify-content-center d-flex  align-content-center  col-12 mt-2 mb-2"
                        onClick={() => { setHostNotAcceptOffer(false) }}>
                        Ok
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ValidationModals;